var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home min-h-screen h-screen min-w-screen w-screen overflow-x-hidden"},[_c('div',{staticClass:"absolute"},[_c('Header')],1),_c('div',{staticClass:"h-full pt-14 bg-gray-1"},[_c('div',{staticClass:"h-full p-5 overflow-y-auto"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }